// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "RouteTable"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: {
        type: "text"
      },
      thStyle: { width: "60px" }
    },
    { key: "RouteId", label: "工艺路线编号", sortable: true, thStyle: { width: "120px" } },
    {
      key: "Name", label: "工艺路线名称", sortable: true,
      thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    { key: "ItemId", label: "物料编号", sortable: true, thStyle: { width: "120px" } },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    // { key: "SEI_InforPackageNo", label: "资料袋编号", sortable: true },
    { key: "dataAreaId", label: "公司", sortable: true },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "date" },
    { key: 'is_approved', label: '审批', sortable: true, type: "boolean" },
    {
      key: 'approved_by_username', label: '审批人', sortable: true,
      formatter: (value, key, item) => {
        if (item.is_approved) {
          return item.approved_by_username
        } else {
          return ""
        }
      }
    },
  ],
  route_detail: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: { width: "60px" }
    },
    // { key: "RouteId", label: "工艺路线编号", sortable: true },
    { key: "OprNum", label: "工序编号", sortable: true, type: "number", editable: true, require: true },
    { key: "OprNumNext", label: "下一个", sortable: true, type: "number", editable: true, require: true },
    { key: "TEC_ProductParts", label: "部件", sortable: true, editable: true, require: true, thStyle: { width: "8rem" } },
    { key: "TEC_RouteType", label: "工序类型", sortable: true, editable: true, require: true, thStyle: { width: "8rem" } },
    { key: "OprId", label: "工序", sortable: true, require: true, thStyle: { width: "8rem" } },
    // { key: "WrkCtrTable_RecId", label: "资源", sortable: true, editable: true },
    { key: "TEC_VariantParameters", label: "变化参数", sortable: true, editable: true, type: "number", require: true },
    { key: "TEC_AccuVariantParameters", label: "累计变化参数", sortable: true, type: "number", require: true },
    { key: "TEC_ColorPositive", label: "正面色序", editable: true, type: "text" },
    { key: "TEC_ColorNumberPositive", label: "正面色组", type: "just_number" },
    { key: "TEC_ColorNegative", label: "反面色序", sortable: true, editable: true, type: "text" },
    { key: "TEC_ColorNumberNegative", label: "反面色组", type: "just_number", _precise: 0, },
    { key: "TEC_ColorNumber", label: "色组数", },
    { key: "TEC_CuttingNo", label: "刀模号", sortable: true, editable: true, type: "textarea" },
    { key: "OprPriority", label: "优先级", sortable: true, editable: true, thStyle: { width: "6rem" } },
    { key: "TEC_DifficultyFactor", label: "难度系数", sortable: true, editable: true, type: "number", require: true },
    { key: "TEC_GoLength", label: "上机长（mm）", sortable: true, editable: true, type: "number" },
    { key: "TEC_GoWidth", label: "上机宽（mm）", sortable: true, editable: true, type: "number" },
    {
      key: "TEC_ImpositionScheme", label: "装版方式", sortable: true,
      thStyle: { width: "12rem" },
      width: "12rem",
      type: "textarea",
      editable: true
    },
    { key: "TEC_PartsDescription", label: "部件说明", sortable: true, editable: true, type: "textarea" },
    { key: "TEC_ProductCatalog", label: "产品类别", sortable: true, editable: true, type: "textarea" },
    {
      key: "TEC_QualityRequirement", label: "包装要求", sortable: true,
      thStyle: { width: "12rem" },
      width: "12rem", type: "textarea", editable: true
    },
    { key: "TEC_Remark", label: "备注", sortable: true, editable: true, type: "textarea" },
    {
      key: "TEC_RouteRequirement", label: "工艺要求", sortable: true,
      thStyle: { width: "12rem" },
      width: "12rem", type: "textarea", editable: true
    },

    { key: "TEC_WorkTime", label: "工作次数", sortable: true, editable: true, type: "number" },
    { key: "TEC_PartsCoefficient", label: "部件系数", sortable: true, editable: true, type: "number", require: true },
    { key: "SEI_OprArea", label: "部件面积", sortable: true, editable: true, type: "number" },
  ],
  route_detail_opr: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: { width: "60px" }
    },
    { key: 'OprId', label: '工序', sortable: true },
    { key: "WrkCtrTable_RecId", label: "资源", sortable: true, thStyle: { width: "12rem" }, editable: true, require: true },
    // { key: 'RouteCode', label: '工艺路线代码', sortable: true },
    // { key: 'RouteRelation', label: '工艺路线关系', sortable: true },
    { key: 'ItemCode', label: '物料代码', sortable: true },
    // { key: 'ItemRelation', label: '物料关系', sortable: true },
    { key: 'ProcessPerQty', label: '标准机器UPH', sortable: true },
    { key: 'StandardWorkHours', label: '标准工时（S)', sortable: true },
    { key: 'UPH', label: 'UPH', sortable: true, editable: true, type: "number", require: true },
    { key: 'SEI_WorkerCountRate', label: '速度达成率', sortable: true },
    { key: 'SEI_WorkerCount1', label: '标准人力', sortable: true, require: true },
    { key: 'SEI_WorkerCount', label: '实际人力', sortable: true, editable: true, type: "just_number" },
    { key: 'SEI_UPPH', label: 'UPPH', sortable: true },
    { key: 'SetupTime', label: '设置时间', sortable: true },
    { key: 'ProcessTime', label: '运行时间', sortable: true },
    { key: 'PerWorkerPrice', label: '单位工价', sortable: true },
    { key: 'TEC_EquipPower', label: '机器功率', sortable: true },
    { key: 'ElectricityPrices', label: '电价', sortable: true },
    { key: 'ToHours', label: '小时/时间', sortable: true },
    { key: 'SetUpCategoryId', label: '设置类别', sortable: true },
    { key: 'ProcessCategoryId', label: '运行时间类别', sortable: true },
    { key: 'QtyCategoryId', label: '数量类别', sortable: true },
    { key: 'RouteType', label: '工艺路线类型', sortable: true, editable: true, thStyle: { width: "6rem" } },
    { key: 'SiteId', label: '站点', sortable: true },
    { key: 'TEC_ProcessPerQty', label: 'SEI单位产能', sortable: true },

  ]
}

const dataForm = {}

///前端验证
const rules = {}
const methods = {
  ///get
  async getRouteIdOptionsData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "get_route_by_searchtext",
      {},
      {}
    )
    let result = await item_biz_data
      .execAction({
        params: _params,
        fields: _.map(fields.default, "key")
      }).run()


    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getDataRoute(_params) {
    const biz_data_route = new biz_data_helper.base_entity_helper(
      "Route",
      create,
      descriptor
    )
    let f = _.map(fields.route_detail, "key")
    f.push("RouteId")
    let result = await biz_data_route
      .selectAction({
        params: _params,
        fields: f
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getDataRouteOpr(_params) {
    const biz_data_route_opr = new biz_data_helper.base_entity_helper(
      "RouteOpr",
      create,
      descriptor
    )

    let result = await biz_data_route_opr
      .selectAction({
        params: _params,
        fields: _.map(fields.route_detail_opr, "key")
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveDataRoute(params) {
    const biz_data_add = new biz_data_helper.base_entity_helper("insert_route_table", {}, {})
    const del_route_detail = new biz_data_helper.base_entity_helper("delete_route_detail", {}, {})

    let _actions = []
    for (var k in params) {
      if (k == "add") {
        _actions.push(
          biz_data_add.execAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "edit") {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "delete") {
        _actions.push(
          biz_data.deleteAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
        _actions.push(
          del_route_detail.execAction({
            params: _.map(params[k], (item) => { return { "RouteId": item.RouteId } }),
            fields: []
          }).action({})
        )
      }
      else if (k == "approved" && params[k].length > 0) {
        _actions.push(
          biz_data.approveAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data[0]
    } else {
      return null
    }
  },
  async saveDataRouteDetail(params) {
    const biz_data_detail = new biz_data_helper.base_entity_helper("Route", {}, {})
    let _actions = []
    for (var k in params) {
      if (k == "add" && params[k].length > 0) {
        _actions.push(
          biz_data_detail.insertAction({
            params: params[k],
            fields: _.map(fields.route_detail, "key")
          }).action({})
        )
      }
      else if (k == "edit" && params[k].length > 0) {
        _actions.push(
          biz_data_detail.updateAction({
            params: params[k],
            fields: _.map(fields.route_detail, "key")
          }).action({})
        )
      }
      else if (k == "delete" && params[k].length > 0) {
        _actions.push(
          biz_data_detail.removeAction({
            params: params[k],
            fields: _.map(fields.route_detail, "key")
          }).action({})
        )
        const biz_data_opr = new biz_data_helper.base_entity_helper("delete_route_opr", {}, {})
        let opr_del_params = _.map(params[k], (t) => {
          return { OprId: t.OprId, RouteRelation: t.RouteId }
        })
        _actions.push(
          biz_data_opr.execAction({
            params: opr_del_params,
            fields: ["id"]
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  async saveDataRouteOpr(params) {
    const biz_data_opr = new biz_data_helper.base_entity_helper("RouteOpr", {}, {})
    let _actions = []
    for (var k in params) {
      if (k == "add") {
        _actions.push(
          biz_data_opr.insertAction({
            params: params[k],
            fields: _.map(fields.route_detail_opr, "key")
          }).action({})
        )
      }
      else if (k == "edit") {
        _actions.push(
          biz_data_opr.updateAction({
            params: params[k],
            fields: _.map(fields.route_detail_opr, "key")
          }).action({})
        )
      }
      else if (k == "delete") {
        _actions.push(
          biz_data_opr.deleteAction({
            params: params[k],
            fields: _.map(fields.route_detail_opr, "key")
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  async checkRouteAction(params) {
    let _actions = []
    if (params.type == "approved") {
      const biz_data_approved = new biz_data_helper.base_entity_helper("check_route_opr_is_ok", {}, {})
      _.each(params.data, (m) => {
        _actions.push(
          biz_data_approved.execAction({
            params: m,
            fields: _.map(fields.default, "key")
          }).action({})
        )
      })
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let rt = { state: true, msg: "", error_nums: [] }
      let check_opr_ok_list = _.filter(result.data.BatchResult.Actions, { Code: "data/e/check_route_opr_is_ok" })
      _.each(check_opr_ok_list, (t) => {
        if (!t.Result || !t.Result.Data || !t.Result.Data[0][0].IsOprOk) {
          rt.state = false
          rt.msg_code = "check_route_opr_not_ok"
          rt.error_nums.push(t.Params[0].id)
        }
      })
      return rt
    } else {
      return null
    }
  }
}
export { biz_data, dataForm, fields, methods, rules };

